import React from "react"
import PropTypes from "prop-types"
import { GatsbyImage } from "gatsby-plugin-image"

import * as styles from "./contact-block.module.css"

const ContactBlockItem = ({ contact }) => {
  const { image, name, position, email, phone } = contact
  return (
    <div className={styles.contactBlockItem}>
      <GatsbyImage image={image?.gatsbyImageData} alt={image?.title || name} />
      <div>
        <h3>{name}</h3>
        <p>
          {position}
          <br />
          <a href={`mailto:${email}`}>{email}</a>
          <br />
          {phone}
        </p>
      </div>
    </div>
  )
}

ContactBlockItem.propTypes = {
  contact: PropTypes.any,
}

ContactBlockItem.defaultProps = {
  contact: {},
}

export default ContactBlockItem
